const collections = [
    {
        "name": "Spanning the Globe",
        "thumbnail": "previewImages/Channel Spanning the Globe Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_gi0h7nwn"
            }
        ]
    },
    {
        "name": "Get the Stitch with Chels",
        "thumbnail": "previewImages/Channel Get the Stitch with Chels Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_eqgx04va"
            }
        ]
    },
    {
        "name": "Technically Speaking",
        "thumbnail": "previewImages/Channel Technically Speaking Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_jhwiy5tv"
            }
        ]
    },
    {
        "name": "Retirement Services",
        "thumbnail": "previewImages/Channel Retirement Services Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_m6eegjuz"
            }
        ]
    },
    {
        "name": "Board of Directors Announcement",
        "thumbnail": "previewImages/Channel Connection 2026 - FY26 Kickoff Thumbnail.jpg",
        "playlists": [
            {
                "name": "Full Recording",
                "playlistId": "1_kfmo6fxe"
            },
            {
                "name": "Segments",
                "playlistId": "1_s3qus6as"
            }
        ]
    },
    {
        "name": "F26 Q2",
        "thumbnail": "previewImages/Channel Global Sales All Hands Call Thumbnail.jpg",
        "playlists": [
            {
                "name": "F26 Q2",
                "playlistId": "1_h4l5u8q9"
            }
        ]
    },
    {
        "name": "Referral to Roll Call",
        "thumbnail": "previewImages/Channel Referral to Roll Call Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_mclc89bu"
            }
        ]
    },
    {
        "name": "Set Up & Ready for Takeoff?",
        "thumbnail": "previewImages/Channel Set Up & Ready for Takeoff_ Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_5l03lth2"
            }
        ]
    },
    {
        "name": "ADP Talks",
        "thumbnail": "previewImages/Channel ADP Talks Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_qxnq2pxt"
            }
        ]
    },
    {
        "name": "The One Big Beautiful Bill Act",
        "thumbnail": "previewImages/Channel The One Big Beautiful Bill Act Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_kte6x9ek"
            }
        ]
    },
    {
        "name": "What's Hot in SBS",
        "thumbnail": "previewImages/Channel What's Hot in SBS Thumbnail.jpg",
        "playlists": [
            {
                "name": "FY26",
                "playlistId": "1_29t57a89"
            }
        ]
    },
    {
        "name": "ESI FY26 Bootcamp",
        "thumbnail": "previewImages/Channel ESI FY26 Boot Camp Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_pe9qu3yc"
            }
        ]
    },
    {
        "name": "A Day in the Life",
        "thumbnail": "previewImages/1_ae3hrjia.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_ldgjp6zz"
            }
        ]
    },
    {
        "name": "AI Connection",
        "thumbnail": "previewImages/Channel AI Connection Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_zqxndsaj"
            }
        ]
    },
    {
        "name": "Integration Station",
        "thumbnail": "previewImages/Channel Integration Station Powered by API Central Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_aia4q1r8"
            }
        ]
    },
    {
        "name": "Feature Flash",
        "thumbnail": "previewImages/Channel Feature Flash - Your Product Show Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_vnjn6ky7"
            }
        ]
    },
    {
        "name": "ICHRA 101",
        "thumbnail": "previewImages/1_vzj7a7oi.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_mae1eoub"
            }
        ]
    },
    {
        "name": "The Executive Edge",
        "thumbnail": "previewImages/Channel The Executive Edge Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_w4s78qh5"
            }
        ]
    },
    {
        "name": "Deal it to Digital",
        "thumbnail": "previewImages/1_cnvg41qz.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_f8vh3ttn"
            },
            {
                "name": "Season 2",
                "playlistId": "1_qhk3xnga"
            }
        ]
    },
    {
        "name": "Marketplace Minis",
        "thumbnail": "previewImages/Channel Marketplace Minis Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_cdu7tyjf"
            },
            {
                "name": "Season 2",
                "playlistId": "1_o7gl42b9"
            }
        ]
    },
    {
        "name": "Leading with Learning",
        "thumbnail": "previewImages/1_lc2jt7mj.png",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_c0vm7y6t"
            }
        ]
    },
    {
        "name": "Better Together",
        "thumbnail": "previewImages/Better Together Channel Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_111sx02n"
            }
        ]
    },
    {
        "name": "Take 5 with Today at Work",
        "thumbnail": "previewImages/Channel Take 5 with Today at Work Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_e130aq62"
            },
            {
                "name": "Season 2",
                "playlistId": "1_euo73i1r"
            }
        ]
    },
    {
        "name": "VAR City",
        "thumbnail": "previewImages/Channel VAR City Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_fk0xcnkw"
            }
        ]
    },
    {
        "name": "Pro Talks",
        "thumbnail": "previewImages/Channel Pro Talks Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_9u9zq467"
            }
        ]
    },
    {
        "name": "The Messaging Lab",
        "thumbnail": "previewImages/Channel The Messaging Lab Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_h7rzk7r2"
            }
        ]
    },
    {
        "name": "Know Your Customer: AML",
        "thumbnail": "previewImages/Channel AML (Anti Money Laundering) & KYC (Know Your Client) Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_6hraeqlr"
            }
        ]
    },
    {
        "name": "Work Smarter Not Harder",
        "thumbnail": "previewImages/SMART Thumbnails 1.png",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_s6l2fip3"
            }
        ]
    },
    {
      "name": "Digging in with Diverse Markets",
      "thumbnail": "previewImages/Channel Digging in with Diverse Markets Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_jjp0d33f"
          }
      ]
  },
  {
      "name": "Behind the Lyric",
      "thumbnail": "previewImages/Behind the Lyric Show Thumbnail.png",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_dugabqu6"
          }
      ]
  },
    {
      "name": "The Hennessey Report",
      "thumbnail": "previewImages/Channel The Hennessey Report Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_yty4zrw3"
          }
      ]
  },
    {
      "name": "Leah's Lounge",
      "thumbnail": "previewImages/Leahsloungenew.png",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_iwadzkjb"
          }
      ]
  },
    {
      "name": "The Valiant Approach",
      "thumbnail": "previewImages/Channel The Valiant Approach Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_ywfiz9n7"
          }
      ]
  },
    {
      "name": "Win It in a Minute - Canada",
      "thumbnail": "previewImages/Channel Win It in a Minute - Canada Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_d8dmmk65"
          }
      ]
  },
    {
      "name": "Accountant Channel Insider",
      "thumbnail": "previewImages/Channel Accountant Channel Insider Thumbnail.jpg",
      "playlists": [
          {
              "name": "FY25",
              "playlistId": "1_7o1vd03m"
          }
      ]
  },
    {
      "name": "GAINing Momentum",
      "thumbnail": "previewImages/Channel GAINing Momentum Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_e1jqtqi0"
          }
      ]
  },
  {
      "name": "Built for Banks",
      "thumbnail": "previewImages/Channel Built for Banks Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_6omkydpy"
          }
      ]
  },
    {
      "name": "Insight Network",
      "thumbnail": "previewImages/Channel Insight Network Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_10v7xxn9"
          },
          {
            "name": "Season 2",
            "playlistId": "1_jpu5lz1w"
        }
      ]
  },
    {
      "name": "Spilling the T",
      "thumbnail": "previewImages/Channel Spilling the T with Kelsey Lee Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_7u7qvf0t"
          },
          {
              "name": "Season 2",
              "playlistId": "1_r9b3ltp2"
          },
          {
              "name": "Season 3",
              "playlistId": "1_bcxg2fcd"
          }
      ]
  },
  {
      "name": "Wally's World",
      "thumbnail": "previewImages/Channel Wally's World Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_ny1q2he0"
          }
      ]
  },
    {
      "name": "Pioneers of Product Innovation",
      "thumbnail": "previewImages/Channel Pioneers of Product Innovation Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_65478lqq"
          },
          {
            "name": "Season 2",
            "playlistId": "1_z39lwj0s"
        }
      ]
  },
    {
      "name": "Lyrically Speaking",
      "thumbnail": "previewImages/Channel Lyrically Speaking Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_68m1jxbm"
          }
      ]
  },
  {
      "name": "The Meeting",
      "thumbnail": "previewImages/Channel The Meeting Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1 - Banks",
              "playlistId": "1_ackahimb"
          }
      ]
  },
    {
      "name": "MAS Quarterly Update",
      "thumbnail": "previewImages/The Quarterly Update - Show TN.png",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_smaih0hc"
          }
      ]
  },
    {
      "name": "The Digital Leadership Lab",
      "thumbnail": "previewImages/Channel The Digital Leadership Lab Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_xmgqa5md"
          }
      ]
  },
    {
      "name": "Get to Know GSO",
      "thumbnail": "previewImages/Channel Get to Know GSO Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_836al8k3"
          }
      ]
  },
  {
      "name": "HR Re-Imagined",
      "thumbnail": "previewImages/HR Re-Imagined Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_21t3hbby"
          }
      ]
  },
  {
      "name": "Digital Sales Elite Perspective",
      "thumbnail": "previewImages/Channel Digital Sales Elite Perspective Thumbnail.jpg",
      "playlists": [
          {
              "name": "Carrie Pysher - Leader",
              "playlistId": "1_cofxfri9"
          }
      ]
  },
    {
      "name": "Leading Ladies of ADP",
      "thumbnail": "previewImages/Channel Leading Ladies of ADP Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_wiw4aodb"
          }
      ]
  },
    {
      "name": "SL+ Live the Pod",
      "thumbnail": "previewImages/Channel Sales Learning+ Live - The Pod Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_qail1b0a"
          }
      ]
  },
     {
      "name": "Lead with Tech & AI",
      "thumbnail": "previewImages/Channel Lead with Tech & AI Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_7v4cs7ys"
          },
           {
              "name": "Season 2",
              "playlistId": "1_t48p73pf"
          },
          {
             "name": "Season 3",
             "playlistId": "1_lje5rhoj"
         }
      ]
  },
  {
      "name": "Dialogues au sommet",
      "thumbnail": "previewImages/Channel Dialogues au sommet Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_vrxkarf4"
          }
      ]
  },
  {
      "name": "The Sales Conversation with Corporate Visions",
      "thumbnail": "previewImages/Channel The Sales Conversation with Corporate Visions Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_452bqkf7"
          },
          {
              "name": "Season 2",
              "playlistId": "1_yr0kij7c"
          }
      ]
  },
  {
      "name": "Behind the Desk",
      "thumbnail": "previewImages/Channel Behind the Desk Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_mr7yvgsl"
          },
          {
              "name": "Season 2",
              "playlistId": "1_zzsi43mt"
          },
          {
              "name": "Season 3",
              "playlistId": "1_zxe6o4nd"
          },
          {
              "name": "Season 4",
              "playlistId": "1_2np7r88z"
          }
      ]
  },
    {
      "name": "PodLife",
      "thumbnail": "previewImages/Channel PODLife Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_eezw6ruy"
          },
          {
              "name": "Season 2",
              "playlistId": "1_28z24ujp"
          },
          {
              "name": "Season 3",
              "playlistId": "1_txhp4pvh"
          }
      ]
  },
    {
      "name": "Sales Learning Plus Update",
      "thumbnail": "previewImages/SLPlusUpdateThumbnail.jpg",
      "playlists": [
          {
              "name": "FY24",
              "playlistId": "1_wziofwq1"
          }
      ]
  },
    {
        "name": "Senior Leader Top Picks",
        "thumbnail": "previewImages/Top Picks Show Thumbnail.jpg",
        "playlists": [
            {
                "name": "Laci Buzelli",
                "playlistId": "1_4wlpkuxp"
            }
        ]
  },
  {
      "name": "Best of BPO",
      "thumbnail": "previewImages/Channel Best in BPO Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_1dqq3i3q"
          },
          {
              "name": "Season 2",
              "playlistId": "1_lktwp2cj"
          }
      ]
  },
  {
      "name": "MAS TV",
      "thumbnail": "previewImages/MAS TV Thumbnail.png",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_w1qtb15f"
          },
          {
              "name": "Season 2",
              "playlistId": "1_0wdr77f4"
          },
          {
              "name": "Season 3",
              "playlistId": "1_6606nmbn"
          }
      ]
  },
  {
      "name": "Let's Get Digital",
      "thumbnail": "previewImages/letsgetdigitalshowthumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_3tkqxd53"
          }
      ]
  },
  {
      "name": "Objection to Opportunity",
      "thumbnail": "previewImages/Channel Objection to Opportunity Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_8w3uqiru"
          },
          {
              "name": "Season 2",
              "playlistId": "1_kcwdr1a7"
          },
          {
              "name": "Season 3",
              "playlistId": "1_3hzok3na"
          }
      ]
  },
  {
      "name": "Global Entry",
      "thumbnail": "previewImages/Channel Global Entry Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_lxvj66bu"
          }
      ]
  },
  {
      "name": "Reference Ready",
      "thumbnail": "previewImages/ReferenceReadyThumbnail.png",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_nbr391zn"
          }
      ]
  },
  {
      "name": "Raising the Bar with Brokers",
      "thumbnail": "previewImages/Channel Raising the Bar with Brokers Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_artiiqrc"
          }
      ]
  },
  {
      "name": "Managed Services Shorts",
      "thumbnail": "previewImages/Channel Managed Services Shorts Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_9gvxxk77"
          }
      ]
  },
  {
      "name": "Cracking the Code with JJ the CPA",
      "thumbnail": "previewImages/Channel Cracking the Code with JJ the CPA Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_peqar7zu"
          }
      ]
  },
  {
      "name": "PreSales Integration",
      "thumbnail": "previewImages/Channel PreSales Integration Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_7gyugv9b"
          }
      ]
  },
  {
      "name": "Win It Right",
      "thumbnail": "previewImages/WinItRightShowThumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_m14m0wrv"
          }
      ]
  },
  {
      "name": "Revenue Fuel",
      "thumbnail": "previewImages/RevenueFuelShowThumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_2ucze55f"
          },
          {
              "name": "Season 2",
              "playlistId": "1_yoj3yhob"
          }
      ]
  },
  {
      "name": "Q4",
      "thumbnail": "previewImages/q4showthumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_f4p17xa0"
          }
      ]
  },
  {
      "name": "Qualification with MEDDICC",
      "thumbnail": "previewImages/MEDDICC Thumbnail.png",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_i2ksdzjt"
          },
          {
              "name": "Season 2",
              "playlistId": "1_8krfol12"
          }
      ]
  },
  {
      "name": "What The Tech!?",
      "thumbnail": "previewImages/What the Tech Series thumbnail.png",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_78eg4g7b"
          },
          {
              "name": "Season 2",
              "playlistId": "1_18m46wf5"
          }
      ]
  },
  {
      "name": "Gotta Minute",
      "thumbnail": "previewImages/gotta minute show thumbnail.png",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_m75ds47v"
          }
      ]
  },
  {
      "name": "The Avatar Show",
      "thumbnail": "previewImages/CI_Avatars_Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_1d2ujv9u"
          },
          {
              "name": "Season 2",
              "playlistId": "1_53t2e0we"
          }
      ]
  },
  {
        "name": "Workforce Newsroom Spotlight",
        "thumbnail": "previewImages/Spotlight Title.png",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_19bjuagq"
            }
        ]
  },
  {
        "name": "Sales Learning Plus Live",
        "thumbnail": "previewImages/SLPlusLiveShowThumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_96onzy8c"
            },
            {
                "name": "Season 2",
                "playlistId": "1_2d8t8b3s"
            },
            {
                "name": "Season 3",
                "playlistId": "1_4rfxn3hl"
            }
        ]
  },
  {
        "name": "Leader Updates",
        "thumbnail": "previewImages/leaderupdatesthumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_m4764auh"
            }
        ]
  },
  {
        "name": "SBS Elite Perspective",
        "thumbnail": "previewImages/sbseliteperspective.jpg",
        "playlists": [
            {
                "name": "Jeremy Dyer",
                "playlistId": "1_1ecn6mbt"
            },
            {
                "name": "Stacy Bolser",
                "playlistId": "1_7lp10jzu"
            },
            {
                "name": "Jenee Nentwig",
                "playlistId": "1_r0rgpjp7"
            }
        ]
  },
    {
        "name": "HRO Canada in 5",
        "thumbnail": "previewImages/HRO Canada in 5 Thumbnail.png",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_mqftifgq"
            },
            {
                "name": "Season 2",
                "playlistId": "1_ignr0wfy"
            }
        ]
  },
    {
        "name": "What's Important Now for Sales",
        "thumbnail": "previewImages/WINS Show Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_sopda4fd"
            }
        ]
  },
    {
        "name": "Competitive Success - The 101",
        "thumbnail": "previewImages/CompetitiveSuccess_Thumbnail.jpg",
        "playlists": [
            {
                "name": "Season 1",
                "playlistId": "1_92xlit3i"
            },
            {
                "name": "Season 2",
                "playlistId": "1_1kueex7i"
            }
        ]
  },
  {
    "name": "Make Your Message Matter",
    "thumbnail": "previewImages/MakeYourMessageMatter.png",
    "playlists": [
      {
        "name": "Season 1",
        "playlistId": "1_t58lg6vo"
      },
      {
        "name": "Season 2",
        "playlistId": "1_8kmv4ads"
      },
      {
          "name": "Season 3",
          "playlistId": "1_ao13z6kl"
      }
    ]
  },
  {
    "name": "CI on the Fly",
    "thumbnail": "previewImages/CIOnTheFly.jpg",
    "playlists": [
      {
        "name": "Season 1",
        "playlistId": "1_sxzohcku"
      },
      {
        "name": "Season 2",
        "playlistId": "1_bv779c80"
      },
      {
        "name": "Season 3",
        "playlistId": "1_rx8esl23"
      },
      {
        "name": "Season 4",
        "playlistId": "1_d607tjwf"
      }
    ]
  },
  {
    "name": "HiPer Curious",
    "thumbnail": "previewImages/HiPerCurious.png",
    "playlists": [
        {
            "name": "Season 1",
            "playlistId": "1_1sa9fr0z"
        },
        {
            "name": "Season 2",
            "playlistId": "1_dokkeujm"
        },
        {
            "name": "Season 3",
            "playlistId": "1_s3src5uf"
        }
    ]
  },
  {
      "name": "Tool Talk",
      "thumbnail": "previewImages/Tool Talk TN 1.png",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_z1oh8ikk"
          }
      ]
  },
//   {
//       "name": "Half Time With Coach Dan",
//       "thumbnail": "previewImages/HalfTimeWithCoachDan.png",
//       "playlists": [
//           {
//               "name": "Season 1",
//               "playlistId": "1_7v9rye8c"
//           }
//       ]
//   },
  {
      "name": "Modern Leader Connect",
      "thumbnail": "previewImages/ModernLeaderConnect.png",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_b1rth3f1"
          }
      ]
  },
  {
      "name": "Genuinely Curious Presents",
      "thumbnail": "previewImages/GC Presents.png",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_x8xhe2lb"
          },
          {
              "name": "Season 2",
              "playlistId": "1_ttnnf5p6"
          },
          {
              "name": "Season 3",
              "playlistId": "1_6ipvl792"
          },
          {
              "name": "Season 4",
              "playlistId": "1_0urc0pe9"
          },
          {
              "name": "Season 5",
              "playlistId": "1_qdl0z86g"
          },
          {
              "name": "Season 6",
              "playlistId": "1_brvs5upk"
          },
          {
              "name": "Season 7",
              "playlistId": "1_zkmxgyz1"
          },
          {
              "name": "Season 8",
              "playlistId": "1_cu2z5hln"
          }
      ]
  },
  {
      "name": "LeaderFlix",
      "thumbnail": "previewImages/LeaderFlixWidescreen.png",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_cn52itun"
          },
          {
              "name": "Season 2",
              "playlistId": "1_sr973vbx"
          },
          {
              "name": "Season 3",
              "playlistId": "1_0gmhccos"
          },
          {
              "name": "Season 4",
              "playlistId": "1_p2b3zuue"
          },
          {
              "name": "Season 5",
              "playlistId": "1_5t9zu1ww"
          },
          {
              "name": "Season 6",
              "playlistId": "1_rqxx8q3n"
          },
          {
            "name": "Season 7",
            "playlistId": "1_1v82lio0"
        }
      ]
  },
  {
      "name": "Thought Leadership",
      "thumbnail": "previewImages/Thumbnail_ThoughtLeadership.png",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_1twn39ze"
          }
      ]
  },
  {
      "name": "Main Street Macro",
      "thumbnail": "previewImages/MSM Logo.png",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_den2ighe"
          }
      ]
  },
  {
      "name": "Workforce News Minute",
      "thumbnail": "previewImages/WFNM Logo.png",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_8pslyeh9"
          }
      ]
  },
  {
      "name": "Win It In A Minute",
      "thumbnail": "previewImages/WinItInAMinute Thumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_etj6a8wi"
          },
          {
              "name": "Season 2",
              "playlistId": "1_frojej82"
          },
          {
              "name": "Season 3",
              "playlistId": "1_o7bzs7af"
          }
      ]
  },
  {
      "name": "Let's Talk WFN",
      "thumbnail": "previewImages/LetsTalkAboutWFN.png",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_o18uslgx"
          }
      ]
  },
  {
      "name": "Let's Talk RUN",
      "thumbnail": "previewImages/LetsTalkAboutRUN.png",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_e3nh1fws"
          }
      ]
  },
//   {
//       "name": "What Was THAT About",
//       "thumbnail": "previewImages/WWTA_ShowThumbnail.png",
//       "playlists": [
//           {
//               "name": "Season 1",
//               "playlistId": "1_obrrq4wx"
//           }
//       ]
//   },
  {
      "name": "Power Generation",
      "thumbnail": "previewImages/PowerGenerationShowThumbnail.jpg",
      "playlists": [
          {
              "name": "Season 1",
              "playlistId": "1_fc0bozy2"
          }
      ]
  }
]

export default collections;